module.exports = __webpack_public_path__ + "img/radio.410088d9.svg";